import moment from 'moment';

export const announcementsHeaders = [
  {
    title: "Titulek",
    align: "left",
    sortable: true,
    key: "title",
    width: 200
  },
  {
    title: "Typ oznámení",
    align: "center",
    sortable: false,
    key: "announcementTypeId",
    width: 75
  },
  {
    title: "Stále viditelné",
    align: "center",
    sortable: false,
    key: "isPermanent",
    width: 50
  },
  {
    title: "Paralelně zobrazované",
    align: "center",
    sortable: false,
    key: "blockParallel",
    width: 50
  },
  {
    title: "Období zobrazování",
    align: "center",
    sortable: false,
    key: "displayTo",
    width: 90
  },
  {
    title: "Akce",
    align: "center",
    sortable: false,
    key: "action",
    width: 120
  },
  {
    title: "Doba zobrazení [s]",
    align: "center",
    sortable: false,
    key: "duration",
    width: 30
  }
];

export const daysOfWeek = (displayFrom, displayTo) => {
  const days = [
    { name: 'Po', index: 1 },
    { name: 'Út', index: 2 },
    { name: 'St', index: 3 },
    { name: 'Čt', index: 4 },
    { name: 'Pá', index: 5 },
    { name: 'So', index: 6 },
    { name: 'Ne', index: 7 }
  ];
  if (!displayTo) return days;
  let beginDay = moment.unix(displayFrom).weekday();
  const diff = moment.unix(displayTo).diff(moment.unix(displayFrom), 'days')+1;
  if (diff >= 7) return days;
  let i;
  let locDays = [];
  for (i = 0; i < diff; i++) {
    locDays.push(days[beginDay]);
    if (beginDay === 6) {
      beginDay = 0;
    } else beginDay++;
  }
  return locDays;
};
